@if (years && years.length > 0) {
  <div class="flex flex-column gap-1">
    <app-check-all
      class="ml-auto"
      [(selection)]="widget.widget.disabledYears"
      [items]="years"
      (selectionChange)="updateWidget()"></app-check-all>
    <div class="flex flex-column flex-wrap gap-1 h-10rem">
      @for (year of years; track $index) {
        <p-checkbox
          [ngModel]="isInverseSelected(year)"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="toggleSelection(year, $event)"
          [label]="year + ''"
          [binary]="true"
          [value]="year" />
      }
    </div>
  </div>
}
